
import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Box, Button, Typography, Grid, TableContainer, Table,
  TableBody, TableCell, TableRow, Paper, TextField, MenuItem,
} from "@mui/material";
import { Breadcrumb } from "../../reusableComponent/Reusables";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Print } from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import SearchIcon from "@mui/icons-material/Search";
import dayjs from "dayjs";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import RmstockServices from "../../../services/Rmstock.Services";
import plantMasterService from "../../../services/masters/plantMaster.Service";

// ── Print Styles (untouched) ──────────────────────────────────────────────────
const printStyles = `
  @media screen {
    .print-only { display: none; }
  }
  @media print {
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area { position: absolute; left: 0; top: 0; width: 100%; }
    .no-print { display: none !important; }
    .print-only { display: block !important; }
    .printable-table { width: 100%; border-collapse: collapse; }
    .printable-table th, .printable-table td { padding: 8px; font-size: 12px; }
    .printable-table .MuiTypography-h6 { font-size: 14px; text-align: center; margin-bottom: 10px; }
    .print-header-info {
      display: flex !important; justify-content: space-between;
      align-items: flex-start; margin-bottom: 10px; font-size: 14px; width: 45%;
    }
    .print-header-title { text-align: left; font-weight: bold; font-size: 20px; margin-bottom: 10px; }
    .print-header-field { flex: 0 0 auto; }
  }
`;

// ── Styles (PlantAdd pattern) ─────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Segoe UI', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const formCardSx = {
  background: "#fff",
 
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 3,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 24px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "block",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
  },
  "& input": { color: "#1A202C", fontSize: "13px" },
  "& .MuiSelect-select": { fontSize: "13px", display: "flex", alignItems: "center" },
};

const showBtnSx = {
  height: "36px",
  background: "#2B6CB0",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: "13px",
  fontWeight: 600,
  textTransform: "none",
  px: 3,
  "&:hover": { background: "#1A4F8A" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
};

const printBtnSx = {
  height: "36px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: "13px",
  fontWeight: 600,
  textTransform: "none",
  px: 3,
  "&:hover": { background: "#388E3C" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
};

// Report card styles
const reportCardSx = {
  background: "#fff",
  borderRadius: "12px",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
};

const reportHeaderSx = (color) => ({
  background: color,
  padding: "10px 16px",
  textAlign: "center",
});

const reportTitleSx = {
  fontSize: "13px",
  fontWeight: 700,
  color: "#fff",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
};

// ─────────────────────────────────────────────────────────────────────────────

const RmStockreport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state || null;
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const userPlantId = userInfo.plant_id || "";

  const [successMessage, setSuccessMessage] = useState("");
  const [displayData, setDisplayData] = useState([]);
  const [plantList, setPlantList] = useState([]);
  const [loading, setLoading] = useState(false);
const [modalData, setModalData] = useState({ open: false, title: '', rows: [] });
  const {
    control, watch,
    formState: { errors },
    setError, handleSubmit,
  } = useForm({
    defaultValues: {
      entry_date: editData?.entry_date
        ? dayjs(editData.entry_date).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
      to_date: editData?.entry_date
        ? dayjs(editData.entry_date).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
      plant_id: userPlantId,
    },
  });

  const entryDate = watch("entry_date");
  const toDate = watch("to_date");
  const plantId = watch("plant_id");

  const selectedPlantName = useMemo(
    () => plantList.find((p) => p.plant_id === plantId)?.plant_name || "",
    [plantList, plantId]
  );

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const plantData = await plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" });
        setPlantList(plantData || []);
      } catch (error) {
        setPlantList([]);
        setSuccessMessage("Error fetching plant data");
      } finally {
        setLoading(false);
      }
    }
    fetchData();

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  const handleShow = useCallback(async (formData) => {
    const { entry_date, to_date, plant_id } = formData;
    if (!entry_date) { setError("entry_date", { message: "From Date is required" }); return; }
    if (!to_date) { setError("to_date", { message: "To Date is required" }); return; }
    if (!plant_id) { setError("plant_id", { message: "Plant is required" }); return; }

    try {
      setLoading(true);
      setDisplayData([]);
      const response = await RmstockServices.getRmStockList({ from_date: entry_date, to_date, plant_id });

      let fetchedData = [];
      if (Array.isArray(response?.data)) fetchedData = response.data;
      else if (response?.data && typeof response.data === "object") fetchedData = [response.data];
      else if (Array.isArray(response)) fetchedData = response;
      else if (response && typeof response === "object") fetchedData = [response];

      if (fetchedData.length === 0) {
        setSuccessMessage("No data found for the selected date and plant.");
      } else {
        setSuccessMessage("");
      }

      const summary = fetchedData.reduce(
        (acc, row) => ({
          carbide_opening_stock: parseFloat(row.opening_carbide) || 0,
          acetone_opening_stock: parseFloat(row.opening_acetone) || 0,
          total_carbide_received: (acc.total_carbide_received || 0) + (parseFloat(row.total_carbide_received) || 0),
          total_acetone_received: (acc.total_acetone_received || 0) + (parseFloat(row.total_acetone_received) || 0),
          total_carbide_used: (acc.total_carbide_used || 0) + (parseFloat(row.total_carbide_used) || 0),
          total_acetone_used: (acc.total_acetone_used || 0) + (parseFloat(row.total_acetone_used) || 0),
          available_carbide: parseFloat(row.available_carbide) || 0,
          available_acetone: parseFloat(row.available_acetone) || 0,
          safety_carbide: parseFloat(row.carbide_safety_stock) || 0,
          safety_acetone: parseFloat(row.acetone_safety_stock) || 0,
        }),
        {
          carbide_opening_stock: 0, acetone_opening_stock: 0,
          total_carbide_received: 0, total_acetone_received: 0,
          total_carbide_used: 0, total_acetone_used: 0,
          available_carbide: 0, available_acetone: 0,
          safety_carbide: 0, safety_acetone: 0,
        }
      );
//       const acetoneByDate = JSON.parse(localStorage.getItem("inspectionAcetoneByDate") || "{}");
// let inspectionAcetoneTotal = 0;
// let currentDate = dayjs(entry_date);
// const endDate = dayjs(to_date);

// while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, "day")) {
//   const dateKey = currentDate.format("YYYY-MM-DD");
//   inspectionAcetoneTotal += acetoneByDate[dateKey] || 0;
//   currentDate = currentDate.add(1, "day");
// }

// const totalAcetoneUsed = (summary.total_acetone_used || 0) + inspectionAcetoneTotal;

// const finalSummary = {
//   ...summary,
//   total_acetone_used: totalAcetoneUsed,
//   available_acetone: (summary.acetone_opening_stock || 0) +
//                      (summary.total_acetone_received || 0) -
//                      totalAcetoneUsed,
// };

// setDisplayData([summary]);
setDisplayData([{ ...summary, raw_rows: fetchedData[0]?.raw_rows || [] }]);


    } catch (error) {
      setSuccessMessage(`Failed to fetch stock data: ${error.response?.data?.message || "Please try again."}`);
      setDisplayData([]);
    } finally {
      setLoading(false);
    }
  }, [setError, plantList]);

  const onSubmit = (data) => { handleShow(data); };
  const handlePrint = () => { window.print(); };
  const dateConversion = (date) => {
    if (!date || isNaN(new Date(date).getTime())) return "N/A";
    return dayjs(date).format("DD/MM/YYYY");
  };

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <Box sx={pageSx}>
      {/* Details Modal */}
{/* {modalData.open && (
  <Box sx={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', zIndex:1300, display:'flex', alignItems:'center', justifyContent:'center' }}
    onClick={() => setModalData({ open:false, title:'', rows:[] })}>
    <Box sx={{ background:'#fff', borderRadius:'10px', minWidth:'520px', maxWidth:'700px', maxHeight:'80vh', overflow:'auto', p:0 }}
      onClick={e => e.stopPropagation()}>
      <Box sx={{ background:'#1C3A5E', p:'12px 20px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <Typography sx={{ color:'#fff', fontWeight:700, fontSize:'14px' }}>{modalData.title}</Typography>
        <Typography sx={{ color:'#fff', cursor:'pointer', fontSize:'18px' }} onClick={() => setModalData({ open:false, title:'', rows:[] })}>✕</Typography>
      </Box>
      <Table size="small">
        <TableBody>
          <TableRow sx={{ background:'#F1F5F9' }}>
            <TableCell sx={{ fontWeight:700, fontSize:'12px' }}>Doc No</TableCell>
            <TableCell sx={{ fontWeight:700, fontSize:'12px' }}>Date</TableCell>
            <TableCell sx={{ fontWeight:700, fontSize:'12px' }} align="right">Qty (KG)</TableCell>
          </TableRow>
          {modalData.rows.map((r, i) => (
            <TableRow key={i} sx={{ '&:nth-of-type(even)': { background:'#F8FAFC' } }}>
              <TableCell sx={{ fontSize:'12px' }}>{r.doc_no || '-'}</TableCell>
              <TableCell sx={{ fontSize:'12px' }}>{dayjs(r.date).format('DD/MM/YYYY')}</TableCell>
              <TableCell sx={{ fontSize:'12px' }} align="right">{r.qty}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  </Box>
)} */}

{modalData.open && (
  <Box
    sx={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.55)', zIndex:1300, display:'flex', alignItems:'center', justifyContent:'center' }}
    onClick={() => setModalData({ open:false, title:'', rows:[] })}>
    <Box
      sx={{ background:'#fff', borderRadius:'14px', minWidth:'540px', maxWidth:'680px', maxHeight:'75vh', overflow:'hidden', boxShadow:'0 20px 60px rgba(0,0,0,0.25)', display:'flex', flexDirection:'column' }}
      onClick={e => e.stopPropagation()}>

      {/* Header */}
      <Box sx={{ background:'#1C3A5E', p:'16px 22px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <Box sx={{ display:'flex', alignItems:'center', gap:'10px' }}>
          {/* <Box sx={{ background:'rgba(255,255,255,0.15)', borderRadius:'8px', p:'6px 10px' }}>
            <Typography sx={{ color:'#fff', fontSize:'16px' }}>📋</Typography>
          </Box> */}
          <Box>
            <Typography sx={{ color:'#fff', fontWeight:700, fontSize:'15px' }}>{modalData.title}</Typography>
            {/* <Typography sx={{ color:'rgba(255,255,255,0.7)', fontSize:'11px' }}>{modalData.rows.length} record{modalData.rows.length !== 1 ? 's' : ''} found</Typography> */}
          </Box>
        </Box>
        <Box
          onClick={() => setModalData({ open:false, title:'', rows:[] })}
          sx={{ background:'rgba(255,255,255,0.15)', borderRadius:'50%', width:'30px', height:'30px', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', '&:hover':{ background:'rgba(255,255,255,0.3)' } }}>
          <Typography sx={{ color:'#fff', fontSize:'16px', lineHeight:1 }}>✕</Typography>
        </Box>
      </Box>

      {/* Table Header */}
      <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', background:'#F1F5F9', borderBottom:'2px solid #E2E8F0', px:'20px', py:'10px' }}>
        {['Doc No', 'Date', 'Qty (KG)'].map((h, i) => (
          <Typography key={i} sx={{ fontSize:'12px', fontWeight:700, color:'#475569', textAlign: i===2 ? 'right' : 'left', textTransform:'uppercase', letterSpacing:'0.5px' }}>{h}</Typography>
        ))}
      </Box>

      {/* Rows */}
      <Box sx={{ overflowY:'auto', flex:1 }}>
        {modalData.rows.length === 0 ? (
          <Box sx={{ p:'32px', textAlign:'center' }}>
            <Typography sx={{ color:'#94a3b8', fontSize:'13px' }}>No records found</Typography>
          </Box>
        ) : modalData.rows.map((r, i) => (
          <Box key={i} sx={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', px:'20px', py:'12px', borderBottom:'1px solid #F1F5F9', background: i%2===0 ? '#fff' : '#FAFBFC', '&:hover':{ background:'#EBF4FF' }, transition:'background 0.15s' }}>
            <Typography sx={{ fontSize:'13px', color:'#1C3A5E', fontWeight:600 }}>{r.doc_no || '-'}</Typography>
            <Typography sx={{ fontSize:'13px', color:'#475569' }}>{dayjs(r.date).format('DD/MM/YYYY')}</Typography>
            <Typography sx={{ fontSize:'13px', fontWeight:700, color:'#2B6CB0', textAlign:'right' }}>{parseFloat(r.qty).toFixed(2)}</Typography>
          </Box>
        ))}
      </Box>

      {/* Footer — Total */}
      <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', px:'20px', py:'12px', background:'#1C3A5E', borderTop:'2px solid #E2E8F0' }}>
        <Typography sx={{ fontSize:'13px', fontWeight:700, color:'#fff' }}>Total</Typography>
        <Typography sx={{ fontSize:'13px', color:'rgba(255,255,255,0.6)' }}>{modalData.rows.length} entries</Typography>
        <Typography sx={{ fontSize:'13px', fontWeight:700, color:'#90CDF4', textAlign:'right' }}>
          {modalData.rows.reduce((s, r) => s + parseFloat(r.qty || 0), 0).toFixed(2)} KG
        </Typography>
      </Box>

    </Box>
  </Box>
)}

      {/* Snackbar */}
      <ReusableSnackbar
        open={!!successMessage}
        autoHideDuration={4000}
        message={successMessage}
        severity="info"
        onClose={() => setSuccessMessage("")}
        className="no-print"
      />

      {/* Breadcrumb */}
      <Box sx={breadcrumbSx} className="no-print">
        Dashboard / Reports /{" "}
        <span style={{ color: "#2B6CB0", fontWeight: 600 }}>RM Stock Report</span>
      </Box>

      {/* Page Header */}
      <Box sx={pageHeaderSx} className="no-print">
        <Box sx={pageTitleSx}>
          <DescriptionIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
          RM STOCK REPORT
        </Box>
      </Box>

      {/* Filter Card */}
      <Box sx={formCardSx} className="no-print">
        <Box sx={sectionHeaderSx}>
          <SearchIcon sx={{ fontSize: 18, color: "#fff" }} />
          <Typography sx={sectionTitleSx}>Filter</Typography>
        </Box>

        <Box sx={formBodySx}>
          <Grid container spacing={2} alignItems="flex-end">

            {/* From Date */}
            <Grid item xs={12} sm={6} md={3}>
              <Typography sx={fieldLabelSx}>From Date</Typography>
              <Controller
                name="entry_date"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="date"
                    size="small"
                    fullWidth
                    error={!!errors.entry_date}
                    helperText={errors.entry_date?.message}
                    InputLabelProps={{ shrink: true }}
                    sx={inputSx}
                  />
                )}
              />
            </Grid>

            {/* To Date */}
            <Grid item xs={12} sm={6} md={3}>
              <Typography sx={fieldLabelSx}>To Date</Typography>
              <Controller
                name="to_date"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="date"
                    size="small"
                    fullWidth
                    error={!!errors.to_date}
                    helperText={errors.to_date?.message}
                    InputLabelProps={{ shrink: true }}
                    sx={inputSx}
                  />
                )}
              />
            </Grid>

            {/* Plant */}
            <Grid item xs={12} sm={6} md={3}>
              <Typography sx={fieldLabelSx}>Select Plant</Typography>
              <Controller
                name="plant_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    {...field}
                    error={!!errors.plant_id}
                    helperText={errors.plant_id?.message}
                    sx={inputSx}
                  >
                    {plantList.map((plant) => (
                      <MenuItem key={plant.plant_id} value={plant.plant_id} sx={{ fontSize: "13px" }}>
                        {plant.plant_name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>

            {/* Buttons */}
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: "flex", gap: 1.5 }}>
                <Button
                  onClick={handleSubmit(onSubmit)}
                  disabled={loading}
                  sx={showBtnSx}
                >
                  {loading ? "Loading..." : "Show"}
                </Button>
                <Button
                  startIcon={<Print sx={{ fontSize: 16 }} />}
                  onClick={handlePrint}
                  disabled={displayData.length === 0}
                  sx={printBtnSx}
                >
                  Print
                </Button>
              </Box>
            </Grid>

          </Grid>
        </Box>
      </Box>

      {/* PRINTABLE AREA — report tables untouched */}
      {displayData.length > 0 && (
        <Box className="printable-area">

          {/* Print-only header */}
          <Box sx={{ mb: 3, textAlign: "center" }} className="print-only">
            <Typography variant="h5" sx={{ fontWeight: "bold" }} className="print-header-title">
              RM STOCK REPORT
            </Typography>
            <Box className="print-header-info">
              <Box className="print-header-field">From Date: {dateConversion(entryDate)}</Box>
              <Box className="print-header-field">To Date: {dateConversion(toDate)}</Box>
              <Box className="print-header-field">Plant: {selectedPlantName}</Box>
            </Box>
          </Box>

          <Grid container spacing={3}>

            {/* Carbide Stock Report */}
            <Grid item xs={12} md={6}>
              <Box sx={reportCardSx}>
                <Box sx={reportHeaderSx("#1C3A5E")}>
                  <Typography sx={reportTitleSx}>Carbide Stock Report</Typography>
                </Box>
                <TableContainer component={Paper} className="printable-table" elevation={0}>
                  <Table>
                    <TableBody>
                      {[
                        { label: "Carbide Opening Stock", value: displayData[0].carbide_opening_stock },
                       {
  label: "Total Carbide Received",
  value: displayData[0].total_carbide_received,
  onClick: () => {
    const rows = (displayData[0].raw_rows || [])
      .filter(r => r.rm_name?.toLowerCase() === 'carbide' && parseFloat(r.received_qty) > 0)
      .map(r => ({ doc_no: r.doc_no, date: r.date, qty: r.received_qty }));
    setModalData({ open: true, title: 'Carbide Received - Details', rows });
  }
},
{
  label: "Total Carbide Used",
  value: displayData[0].total_carbide_used,
  onClick: () => {
    const rows = (displayData[0].raw_rows || [])
      .filter(r => r.rm_name?.toLowerCase() === 'carbide' && parseFloat(r.issued_qty) > 0)
      .map(r => ({ doc_no: r.doc_no, date: r.date, qty: r.issued_qty }));
    setModalData({ open: true, title: 'Carbide Used - Details', rows });
  }
},
                        { label: "Available Carbide", value: displayData[0].available_carbide },
                        { label: "Safety Stock Carbide", value: displayData[0].safety_carbide },
                      ].map((row, i) => (
                       <TableRow key={i}
  onClick={row.onClick}
  sx={{
    "&:nth-of-type(even)": { background: "#F8FAFC" },
    cursor: row.onClick ? 'pointer' : 'default',
    "&:hover": row.onClick ? { background: '#EBF4FF' } : {}
  }}>
                          <TableCell sx={{ fontSize: "13px", color: "#475569", fontWeight: 500, borderColor: "#E2E8F0" }}>
                            {row.label}
                          </TableCell>
                          <TableCell align="right" sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E", borderColor: "#E2E8F0" }}>
                            {row.value} <span style={{ fontSize: "11px", color: "#94a3b8" }}>KG</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            {/* Acetone Stock Report */}
            <Grid item xs={12} md={6}>
              <Box sx={reportCardSx}>
                <Box sx={reportHeaderSx("#1C3A5E")}>
                  <Typography sx={reportTitleSx}>Acetone Stock Report</Typography>
                </Box>
                <TableContainer component={Paper} className="printable-table" elevation={0}>
                  <Table>
                    <TableBody>
                      {[
                        { label: "Acetone Opening Stock", value: displayData[0].acetone_opening_stock },
                      {
  label: "Total Acetone Received",
  value: displayData[0].total_acetone_received,
  onClick: () => {
    const rows = (displayData[0].raw_rows || [])
      .filter(r => r.rm_name?.toLowerCase() === 'acetone' && parseFloat(r.received_qty) > 0)
      .map(r => ({ doc_no: r.doc_no, date: r.date, qty: r.received_qty }));
    setModalData({ open: true, title: 'Acetone Received - Details', rows });
  }
},
{
  label: "Total Acetone Used",
  value: displayData[0].total_acetone_used,
  onClick: () => {
    const rows = (displayData[0].raw_rows || [])
      .filter(r => r.rm_name?.toLowerCase() === 'acetone' && parseFloat(r.issued_qty) > 0)
      .map(r => ({ doc_no: r.doc_no, date: r.date, qty: r.issued_qty }));
    setModalData({ open: true, title: 'Acetone Used - Details', rows });
  }
},
                        { label: "Available Acetone", value: displayData[0].available_acetone },
                        { label: "Safety Stock Acetone", value: displayData[0].safety_acetone },
                      ].map((row, i) => (
                       <TableRow key={i}
  onClick={row.onClick}
  sx={{
    "&:nth-of-type(even)": { background: "#F8FAFC" },
    cursor: row.onClick ? 'pointer' : 'default',
    "&:hover": row.onClick ? { background: '#EBF4FF' } : {}
  }}>
                          <TableCell sx={{ fontSize: "13px", color: "#475569", fontWeight: 500, borderColor: "#E2E8F0" }}>
                            {row.label}
                          </TableCell>
                          <TableCell align="right" sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E", borderColor: "#E2E8F0" }}>
                            {row.value} <span style={{ fontSize: "11px", color: "#94a3b8" }}>KG</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

          </Grid>
        </Box>
      )}

    </Box>
  );
};

export default RmStockreport;